import React from 'react';
import { FormData } from '../types/formTypes';

interface BasicInfoFormProps {
  formData: FormData;
  updateFormData: (updates: Partial<FormData>) => void;
}

const BasicInfoForm: React.FC<BasicInfoFormProps> = ({ formData, updateFormData }) => {
  return (
    <div className="form-section">
      <h2>1. 基本情報</h2>
      
      <div className="form-group">
        <label htmlFor="companyName">雇用保険適用事業所の名称 *</label>
        <input
          type="text"
          id="companyName"
          value={formData.companyName}
          onChange={(e) => updateFormData({ companyName: e.target.value })}
          required
        />
      </div>

      <div className="form-group">
        <label htmlFor="insuranceNumber">雇用保険適用事業所番号 *</label>
        <input
          type="text"
          id="insuranceNumber"
          value={formData.insuranceNumber}
          onChange={(e) => updateFormData({ insuranceNumber: e.target.value })}
          placeholder="0000-000000-0"
          required
        />
      </div>

      <div className="form-group">
        <label htmlFor="postalCode">郵便番号 *</label>
        <input
          type="text"
          id="postalCode"
          value={formData.postalCode}
          onChange={(e) => updateFormData({ postalCode: e.target.value })}
          placeholder="123-4567"
          required
        />
      </div>

      <div className="form-group">
        <label htmlFor="address">事業所所在地 *</label>
        <input
          type="text"
          id="address"
          value={formData.address}
          onChange={(e) => updateFormData({ address: e.target.value })}
          required
        />
      </div>

      <h3>担当者情報</h3>
      
      <div className="form-group">
        <label htmlFor="contactName">担当者氏名 *</label>
        <input
          type="text"
          id="contactName"
          value={formData.contactPerson.name}
          onChange={(e) => updateFormData({
            contactPerson: { ...formData.contactPerson, name: e.target.value }
          })}
          required
        />
      </div>

      <div className="form-group">
        <label htmlFor="contactDepartment">部署</label>
        <input
          type="text"
          id="contactDepartment"
          value={formData.contactPerson.department}
          onChange={(e) => updateFormData({
            contactPerson: { ...formData.contactPerson, department: e.target.value }
          })}
        />
      </div>

      <div className="form-group">
        <label htmlFor="contactPhone">電話番号</label>
        <input
          type="tel"
          id="contactPhone"
          value={formData.contactPerson.phone}
          onChange={(e) => updateFormData({
            contactPerson: { ...formData.contactPerson, phone: e.target.value }
          })}
        />
      </div>


      <div className="form-group">
        <label htmlFor="contactEmail">メールアドレス</label>
        <input
          type="email"
          id="contactEmail"
          value={formData.contactPerson.email}
          onChange={(e) => updateFormData({
            contactPerson: { ...formData.contactPerson, email: e.target.value }
          })}
        />
      </div>

      <h3>事業主情報</h3>
      
      <div className="form-group">
        <label htmlFor="businessOwnerPostalCode">事業主郵便番号 *</label>
        <input
          type="text"
          id="businessOwnerPostalCode"
          value={formData.businessOwner.postalCode}
          onChange={(e) => updateFormData({
            businessOwner: { ...formData.businessOwner, postalCode: e.target.value }
          })}
          placeholder="123-4567"
          required
        />
      </div>

      <div className="form-group">
        <label htmlFor="businessOwnerCompanyName">事業主名称 *</label>
        <input
          type="text"
          id="businessOwnerCompanyName"
          value={formData.businessOwner.companyName}
          onChange={(e) => updateFormData({
            businessOwner: { ...formData.businessOwner, companyName: e.target.value }
          })}
          required
        />
      </div>

      <div className="form-group">
        <label htmlFor="businessOwnerRepresentativeName">代表者氏名 *</label>
        <input
          type="text"
          id="businessOwnerRepresentativeName"
          value={formData.businessOwner.representativeName}
          onChange={(e) => updateFormData({
            businessOwner: { ...formData.businessOwner, representativeName: e.target.value }
          })}
          required
        />
      </div>

      <div className="form-group">
        <label htmlFor="businessOwnerCorporateNumber">法人番号</label>
        <input
          type="text"
          id="businessOwnerCorporateNumber"
          value={formData.businessOwner.corporateNumber}
          onChange={(e) => updateFormData({
            businessOwner: { ...formData.businessOwner, corporateNumber: e.target.value }
          })}
          placeholder="1234567890123"
        />
      </div>
    </div>
  );
};

export default BasicInfoForm;